//UsersContext is used in the admin dashboard

import React, {useEffect, useState} from "react";
import {adminUserService} from "../services/admin/admin.customer.service";

const UsersStateContext = React.createContext();
const UsersDispatchContext = React.createContext();
let currentPage = 0;
let currentFilteredTab = "";

const initialState = {
    status: "idle",
    users: {
        rows: [],
        hasMore: true,
        page: 0
    },
    currentPage: 0,
    error: null
};

function reducer(currentState, newState) {
    return { ...currentState, ...newState };
}

function useUsersState() {
    const context = React.useContext(UsersStateContext);
    if (!context) throw new Error("useAuthState must be used in UserProvider");

    return context;
}

function useUsersDispatch() {
    const context = React.useContext(UsersDispatchContext);
    if (!context) throw new Error("useAuthDispatch must be used in UserProvider");

    return context;
}

const loadUsers = async(dispatch, page = 0, query, status) => {
    const res = await adminUserService.searchUsers(page, query, status);
    dispatch({
        state: "resolved",
        users: {
            rows: res.data.users,
            page: res.data.page,
            hasMore: res.data.hasMore,
            currentPage: currentPage
        },
        error: null
    })
}

const handlePreviousUsersClick = async(dispatch) => {
    if (currentPage > 0)
        currentPage--;

    await loadUsers(dispatch, currentPage, "", currentFilteredTab);
}


const handleNextUsersClick = async(dispatch) => {
    currentPage++;
    await loadUsers(dispatch, currentPage, "", currentFilteredTab);
}

const handleUsersSearch = async(dispatch, query) => {
    await loadUsers(dispatch, currentPage, query, currentFilteredTab);
}

const handleActiveUsersTabClick = async(dispatch) => {
    currentPage = 0;
    currentFilteredTab = "active";
    await loadUsers(dispatch, currentPage, "", 'active');
}

const handleAllUsersTabClick = async(dispatch) => {
    currentPage = 0;
    currentFilteredTab = "";
    await loadUsers(dispatch, currentPage, "", '');
}

const handleExpiredUsersTabClick = async(dispatch) => {
    currentPage = 0;
    currentFilteredTab = "expired";
    await loadUsers(dispatch, currentPage, "", 'expired');
}


function UsersProvider(props) {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    useEffect(() => {
       loadUsers(dispatch);
    }, []);

    return (
        <UsersStateContext.Provider value={state}>
            <UsersDispatchContext.Provider value={dispatch}>
                {props.children}
            </UsersDispatchContext.Provider>
        </UsersStateContext.Provider>
    );
}

export {
    UsersProvider,
    useUsersState,
    useUsersDispatch,
    loadUsers,
    handlePreviousUsersClick,
    handleNextUsersClick,
    handleUsersSearch,
    handleActiveUsersTabClick,
    handleAllUsersTabClick,
    handleExpiredUsersTabClick
}